import { Cursors } from '../../types/types'

type SurfaceProps = {
  x: number
  y: number
  width: number
  height: number
  cursor: Cursors
}

const Surface: React.FC<SurfaceProps> = ({ x, y, width, height, cursor = 'auto' }) => {
  const style: React.CSSProperties = {
    left: x,
    top: y,
    width,
    height,
    cursor,
    position: 'absolute',
    touchAction: 'pan-y', // Allow vertical scrolling
  }

  return <div className="surface" style={style}></div>
}

export default Surface
